import { Record as record } from 'immutable';
import { construct, fields } from '../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../helpers/Records';

import ValidationMixin from '../ValidationMixin';

const fieldSchema = {
    customerId: [fields.number],
    email: [fields.string],
    created: [fields.datetime],
    id: [fields.number],
    state: [fields.string],
    updated: [fields.datetime],
};

class DeactivationRequest extends record(getDefaults(fieldSchema)) {

    static fromJSON(json = {}) {
        return construct(DeactivationRequest, json, getResolvers(fieldSchema));
    }
}

Object.assign(DeactivationRequest.prototype, ValidationMixin);

export default DeactivationRequest;
